// import React, { useEffect, useRef, useState } from 'react';
import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Grid, Snackbar} from '@mui/material';
import { Box } from '@mui/system';
// import { EditorState, convertToRaw } from 'draft-js';
// import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { ReqField } from 'src/components/CustomComponents/CustomLoader';
// import { AddCircleOutlineRounded, AddCircleOutlined, CloseOutlined, CloseSharp, DeleteOutline } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import RadioInputs from 'src/components/inputs/RadioInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';

const initialValue = {
    name: '',
    dob: '',
    phone: '',
    mail: '',
    start: '',
    end: '',
    salary: '',
    emergencyContact: '',
    emergencyName: '',
    userName: '',
    password: '',
    gender: '',
    dateOfJoining: '',
    userType: '',
    department: '',
    img1: null,
    img2: null,
    branchDetails: ''
}

const AddStaff = () => {
    const [formData, setFormData] = useState(initialValue);
    const [branches, setBranches] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const handleImage = (e) => {
        // console.log(e.target.files[0], '<<< this is files');
        setFormData({ ...formData, [e.target.name]: e.target?.files[0] });
    };

    const { createStaff, fetchAllBranch } = useMain();

    const getData = async () => {
        const res = await fetchAllBranch({ limit: 50, page: 1 });
        setBranches(res?.data)
    }

    const handleSubmit = async () => {
        // console.log({ ...formData });
        const { name, dob, phone, mail, start, end, salary, emergencyContact, emergencyName, userName, password, gender, dateOfJoining, userType, department, img1, img2, branchDetails } = formData;
        if (name.trim() === '') return setErrorMessage('Client Name is Required');
        if (dob === '') return setErrorMessage('Dob is Required');
        if (gender === '') return setErrorMessage('Gender is Required');
        if (phone === '') return setErrorMessage('Client Number is Required');
        if (userName === '') return setErrorMessage('userName is Required');
        if (mail === '') return setErrorMessage('mail is Required');
        if (start === '') return setErrorMessage('start time is Required');
        if (end === '') return setErrorMessage('end time is Required');
        if (salary === '') return setErrorMessage('Salary is Required');
        if (emergencyContact === '') return setErrorMessage('Emergency Contact is Required');
        if (emergencyName === '') return setErrorMessage('Emergency Name is Required');
        if (password === '') return setErrorMessage('Password is Required');
        if (dateOfJoining === '') return setErrorMessage('Date of Joining is Required');
        if (userType === '') return setErrorMessage('userType is Required');
        if (department === '') return setErrorMessage('Department is Required');
        if (branchDetails === '') return setErrorMessage('Branch is Required');
        if (img1 === null) return setErrorMessage('User Photo is Required');
        if (img2 === null) return setErrorMessage('UserId is Required');

        const formDataUpdated = new FormData();
        formDataUpdated.append('name', name);
        formDataUpdated.append('dob', dob);
        formDataUpdated.append('gender', gender);
        formDataUpdated.append('phone', phone);
        formDataUpdated.append('userName', userName);
        formDataUpdated.append('mail', mail);
        formDataUpdated.append('workingHrs', JSON.stringify({ start, end }));
        formDataUpdated.append('salary', salary);
        formDataUpdated.append('emergencyDetails', JSON.stringify({ contactNo: emergencyContact, name: emergencyName }));
        formDataUpdated.append('password', password);
        formDataUpdated.append('dateOfJoining', dateOfJoining);
        formDataUpdated.append('userType', userType);
        formDataUpdated.append('department', department);
        formDataUpdated.append('branchDetails', branchDetails);
        formDataUpdated.append('images', img1, img1.name);
        formDataUpdated.append('images', img2, img2.name);

        // console.log(...formDataUpdated)

        setShowLoader(true);

        const res = await createStaff(formDataUpdated);

        if (res?.statusCode === 200) {
            setSuccessMessage('Client Successfully Created');
            setTimeout(() => {
                setSuccessMessage('');
            }, 7000);
            setFormData(initialValue);
            setErrorMessage('');
            setShowLoader(false);
        } else {
            setErrorMessage(res?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            setFormData(initialValue);
            setShowLoader(false);
        }
    };

    useEffect(() => {
        getData();

        return () => { }
    }, []);

    return (
        <PageContainer title="Add Staff" description="this is add Staff">
            <DashboardCard title="Add Staff">
                <Snackbar
                    // open={errorMessage == '' ? false : true}
                    open={errorMessage === '' ? false : true}
                    autoHideDuration={6000}
                    onClose={() => {
                        setErrorMessage('');
                    }}
                    severity="error"
                    message={errorMessage}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                />
                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Name'}
                                name={'name'}
                                value={formData?.name}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Date of Birth'}
                                name={'dob'}
                                value={formData?.dob}
                                handleChange={handleChange}
                                type={'date'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Contact Number'}
                                name={'phone'}
                                value={formData?.phone}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Email Address'}
                                name={'mail'}
                                value={formData?.mail}
                                handleChange={handleChange}
                                type={'email'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Monthly Salary'}
                                name={'salary'}
                                value={formData?.salary}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box>
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <TextInputs
                                            title={'Working Hours'}
                                            name={'start'}
                                            value={formData?.start}
                                            handleChange={handleChange}
                                            type={'time'}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextInputs
                                            title={''}
                                            required={false}
                                            name={'end'}
                                            value={formData?.end}
                                            handleChange={handleChange}
                                            type={'time'}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Emergency Contact Number'}
                                name={'emergencyContact'}
                                value={formData?.emergencyContact}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Emergency Contact Person'}
                                name={'emergencyName'}
                                value={formData?.emergencyName}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        {/* <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Address'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid> */}
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Username'}
                                name={'userName'}
                                value={formData?.userName}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Password'}
                                name={'password'}
                                value={formData?.password}
                                handleChange={handleChange}
                                type={'password'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectInputs
                                title={'Select Branch'}
                                name={'branchDetails'}
                                value={formData?.branchDetails}
                                handleChange={handleChange}
                                options={branches}
                                optionTitle={'branchName'}
                                optionValue={'_id'}
                            />
                        </Grid>
                        {/* <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Confirm Password'}
                                name={'confirm'}
                                value={formData?.confirm}
                                // handleChange={handleChange}
                                type={'password'}
                            />
                        </Grid> */}
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <RadioInputs
                                title={'Gender'}
                                name={'gender'}
                                value={formData?.gender}
                                handleChange={handleChange}
                                options={[
                                    { title: 'M', value: 'Male' },
                                    { title: 'F', value: 'Female' }
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'User Type'}
                                name={'userType'}
                                value={formData?.userType}
                                handleChange={handleChange}
                                type={'password'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Department'}
                                name={'department'}
                                value={formData?.department}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Date of Joining'}
                                name={'dateOfJoining'}
                                value={formData?.dateOfJoining}
                                handleChange={handleChange}
                                type={'date'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Upload Photo'}
                                name={'img1'}
                                value={formData?.img1}
                                handleChange={handleImage}
                                type={'file'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Upload Id'}
                                name={'img2'}
                                value={formData?.img2}
                                handleChange={handleImage}
                                type={'file'}
                            />
                        </Grid>
                    </Grid>
                </Box>


                {showLoader && <ShowLoader value={showLoader} />}
                {successMessage !== '' && <ShowSuccess message={successMessage} />}

                <div style={{ width: '200px', margin: '3rem auto' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        sx={{
                            background: '#6174DD'
                        }}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </DashboardCard>
        </PageContainer>
    )
}

export default AddStaff